export const AGENT_ACTIVITY_LOG_SAFETY_POLL_INTERVAL_MS = 15 * 1000;

const DELEGATED_AGENT_ACTIVITY_LOG_STATUSES = new Set(['ACTIVE', 'QUEUED']);

/**
 * Returns whether task activity logs should use safety polling while waiting for agent updates.
 */
export function shouldSafetyPollAgentActivityLogs(isAgentDelegated: boolean, delegateStatus?: string | null): boolean {
  return isAgentDelegated && DELEGATED_AGENT_ACTIVITY_LOG_STATUSES.has(delegateStatus ?? '');
}
